import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { decrementTimer, closeWarning } from '@application/features/workorders/workorderSlice';
import { AiOutlineWarning } from 'react-icons/ai'; // Warning icon
import { VisserModule } from '@application/common/enums/visser-module'; // Import VisserModule for module-specific navigation
import { useAppDispatch } from '@application/store/useStore';
import { useNavigate } from 'react-router-dom';
const PersistentWarningMessage = forwardRef(({ recordId, moduleId, handleIsModuleLockReset }, ref) => {
    const dispatch = useAppDispatch();
    const timeRemaining = useSelector((state) => state.workorder.timeRemaining);
    const isWarningVisible = useSelector((state) => state.workorder.isWarningVisible);
    const [isMinimized, setIsMinimized] = useState(false);
    const navigate = useNavigate();
    const intervalRef = useRef(null);
    useEffect(() => {
        let lastActiveTime = Date.now();
        const startTimer = () => {
            if (intervalRef.current)
                clearInterval(intervalRef.current);
            intervalRef.current = window.setInterval(() => {
                const currentTime = Date.now();
                const elapsedSeconds = Math.floor((currentTime - lastActiveTime) / 1000);
                // Calculate the time remaining based on real-time difference
                dispatch(decrementTimer(elapsedSeconds)); // Adjust to pass the elapsed time
                lastActiveTime = currentTime;
            }, 1000); // Still checking every second
        };
        startTimer();
        // Cleanup the interval when the component unmounts
        return () => {
            if (intervalRef.current)
                clearInterval(intervalRef.current);
        };
    }, [dispatch]);
    useEffect(() => {
        if (timeRemaining === 0) {
            if (moduleId === VisserModule.Werkorder) {
                const moduleLockRequestData = {
                    moduleId: VisserModule.Werkorder,
                    recordId: recordId
                };
                handleIsModuleLockReset && handleIsModuleLockReset(true);
                navigate("/admin/WorkordersList");
            }
            if (moduleId == VisserModule.Offertes) {
                handleIsModuleLockReset && handleIsModuleLockReset(true);
                navigate("/admin/Quotation");
            }
            if (moduleId == VisserModule.Facturen) {
                handleIsModuleLockReset && handleIsModuleLockReset(true);
                navigate("/admin/InvoicesList");
            }
            if (moduleId == VisserModule.Inkoopfacturen) {
                handleIsModuleLockReset && handleIsModuleLockReset(true);
                navigate("/admin/PurchaseInvoiceList");
            }
            if (moduleId === VisserModule.Bestellingen) {
                handleIsModuleLockReset && handleIsModuleLockReset(true);
                navigate("/admin/OrdersList");
            }
            // Add other module navigations here if needed
        }
    }, [timeRemaining, moduleId, recordId]);
    const handleToggleMinimize = () => {
        setIsMinimized((prevState) => !prevState);
    };
    const handleClose = () => {
        dispatch(closeWarning()); // Close the warning
    };
    if (!isWarningVisible) {
        return null;
    }
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    return (_jsx("div", { className: `toaster-container ${isMinimized ? 'minimized' : ''}`, children: !isMinimized ? (_jsxs("div", { className: 'toaster-content', children: [_jsxs("div", { className: 'row', children: [_jsxs("div", { className: 'col-2', children: [_jsx(AiOutlineWarning, { size: 20, style: { marginRight: '8px' } }), _jsx("p", { className: 'mt-2', children: `${minutes}:${seconds < 10 ? '0' : ''}${seconds}` })] }), _jsxs("div", { className: 'col-9', children: [_jsx("strong", { children: "Inactiviteit Gedetecteerd!" }), _jsx("p", { className: 'mt-2', children: "Vanwege inactiviteit worden uw niet-opgeslagen wijzigingen verwijderd als er binnen de volgende 2 minuten geen activiteit is." })] })] }), _jsx("span", { onClick: handleToggleMinimize, className: 'custom-toaster-close-button', children: "X" })] })) : (_jsxs("div", { className: 'minimized-toaster', onClick: handleToggleMinimize, children: [_jsx(AiOutlineWarning, { size: 20, style: { marginRight: '8px' } }), _jsx("p", { className: 'mt-3', children: `${minutes}:${seconds < 10 ? '0' : ''}${seconds}` })] })) }));
});
export default PersistentWarningMessage;
